import type { OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import { FontColor, TextSize } from '@freelancer/ui/text';
import { textVariants } from '../tailwind-text';
import { CompletedJobsSize } from './completed-jobs.types';

@Component({
  selector: 'fl-completed-jobs',
  template: `
    <fl-icon
      [name]="'ui-chart-donut'"
      [size]="size"
      [sizeTablet]="sizeTablet"
      [sizeDesktop]="sizeDesktop"
      [sizeDesktopLarge]="sizeDesktopLarge"
      [color]="
        completeCounter === 0 ? IconColor.FOREGROUND : IconColor.SECONDARY
      "
      [flMarginRight]="'xxxsmall'"
    ></fl-icon>

    <p [class]="completedTextClass">{{ completeCounter }}%</p>
  `,
  styleUrls: ['./completed-jobs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompletedJobsComponent implements OnInit, OnChanges {
  IconColor = IconColor;
  IconSize = IconSize;
  TextSize = TextSize;
  FontColor = FontColor;

  completedTextClass: string;

  private completedTextSize: TextSize = TextSize.SMALL;
  private completedTextSizeTablet?: TextSize | undefined;
  private completedTextSizeDesktop?: TextSize | undefined;
  private completedTextSizeDesktopLarge?: TextSize | undefined;

  @Input() completeCounter = 0;

  @Input() size: CompletedJobsSize = IconSize.MID;
  @Input() sizeTablet?: CompletedJobsSize;
  @Input() sizeDesktop?: CompletedJobsSize;
  @Input() sizeDesktopLarge?: CompletedJobsSize;

  ngOnInit(): void {
    this.calculateStyles();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      'size' in changes ||
      'sizeTablet' in changes ||
      'sizeDesktop' in changes ||
      'sizeDesktopLarge' in changes
    ) {
      this.calculateStyles();
    }
  }

  private calculateStyles(): void {
    switch (this.size) {
      case IconSize.SMALL:
        this.completedTextSize = TextSize.XXSMALL;
        break;
      default:
        this.completedTextSize = TextSize.SMALL;
    }

    switch (this.sizeTablet) {
      case IconSize.SMALL:
        this.completedTextSizeTablet = TextSize.XXSMALL;
        break;
      case IconSize.MID:
        this.completedTextSizeTablet = TextSize.SMALL;
        break;
      default:
        this.completedTextSizeTablet = undefined;
    }

    switch (this.sizeDesktop) {
      case IconSize.SMALL:
        this.completedTextSizeDesktop = TextSize.XXSMALL;
        break;
      case IconSize.MID:
        this.completedTextSizeDesktop = TextSize.SMALL;
        break;
      default:
        this.completedTextSizeDesktop = undefined;
    }

    switch (this.sizeDesktopLarge) {
      case IconSize.SMALL:
        this.completedTextSizeDesktopLarge = TextSize.XXSMALL;
        break;
      case IconSize.MID:
        this.completedTextSizeDesktopLarge = TextSize.SMALL;
        break;
      default:
        this.completedTextSizeDesktopLarge = undefined;
    }

    this.completedTextClass = textVariants({
      size: this.completedTextSize,
      sizeTablet: this.completedTextSizeTablet,
      sizeDesktop: this.completedTextSizeDesktop,
      sizeDesktopLarge: this.completedTextSizeDesktopLarge,
    });
  }
}
